import React from 'react';
import Viewport from 'cf-component-viewport';

const PageLayout = (props) => {
  return (
    <div className="flex fg1">
      <Viewport size="tablet">
        {props.sidebar}
      </Viewport>

      <Viewport size="desktop">
        {props.sidebar}
      </Viewport>

      <Viewport size="desktopLarge">
        {props.sidebar}
      </Viewport>

      <div className="fg1 flex box-shadow-custom mw7">{props.content}</div>

      <Viewport size="desktopLarge">
        <div className="fg1 bg-near-white"></div>
      </Viewport>
    </div>
  )
}

export default PageLayout;


/** WEBPACK FOOTER **
 ** ./src/components/layouts/PageLayout.js
 **/